/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gespr_Chsf_Hrung1Inputs */

const de__field_gespr_chsf_hrung1 = /** @type {(inputs: _Field_Gespr_Chsf_Hrung1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächsführung`)
};

/**

* @param {_Field_Gespr_Chsf_Hrung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gespr_chsf_hrung1 = /** @type {((inputs?: _Field_Gespr_Chsf_Hrung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gespr_Chsf_Hrung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_gespr_chsf_hrung1(inputs)
});
export { _field_gespr_chsf_hrung1 as "_field_Gesprächsführung" }